import type { IconSvgObject } from './types';

const ArrowBigDownDashIcon: IconSvgObject = [
  ["path", { d: "M9 11H5.45377C4.65087 11 4 11.6509 4 12.4538C4 12.8059 4.12781 13.1461 4.3597 13.4111L10.3415 20.2474C10.76 20.7257 11.3645 21 12 21C12.6355 21 13.24 20.7257 13.6585 20.2474L19.6403 13.4111C19.8722 13.1461 20 12.8059 20 12.4538C20 11.6509 19.3491 11 18.5462 11H15V8C15 7.44772 14.5523 7 14 7H10C9.44772 7 9 7.44772 9 8V11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 3H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowBigDownDashIcon;
